<template>
  <div>
    <div class="div-title uppercase text-center pb-3.5 border-b border-b-gray-400 mb-8">
      <h1 class="text-4xl">
        ALL-AMERICAN STANDINGS
      </h1>
    </div>

    <div class="mb-8 p-2 w-full flex flex-wrap bg-grey-light" v-if="ready">
      <div v-if="!isLoggedIn" class="text-center w-full pt-10 pb-6">
        <!--        <svg class="w-10 inline-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">-->
        <!--          <path-->
        <!--              d="M80 192V144C80 64.47 144.5 0 224 0C303.5 0 368 64.47 368 144V192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256C0 220.7 28.65 192 64 192H80zM144 192H304V144C304 99.82 268.2 64 224 64C179.8 64 144 99.82 144 144V192z"/>-->
        <!--        </svg>-->
        <template v-if="arabian">
          <h2 class="text-[28px] md:text-[41px] max-w-[570px] mx-auto font-normal font-title uppercase">This area is restricted to members</h2>
        </template>
        <template v-else>
          <h2 class="text-[28px] md:text-[41px] max-w-[570px] mx-auto font-normal font-title uppercase">This area is restricted to subscribers</h2>
          <p class="font-normal text-2xl mb-8">You need to have an active print or digital subscription</p>
        </template>


        <div class="flex flex-col justify-center sm:flex-row bg-blackLight max-w-[820px] mx-auto mb-4 sm:mb-10 min-h-[330px]">

          <div class="w-full sm:basis-1/2 relative">
            <div class="absolute  top-[-100px] left-[-2%] sm:top-[-20px] sm:left-[-20px] z-[1] opacity-20 sm:opacity-100">
              <nuxt-img
                  format="webp"
                  preload
                  src="/subscribe/member-img-horse.png" alt="member subscribe" width="401" height="363"/>
            </div>
          </div>
          <div class="w-full sm:basis-1/2 flex flex-col justify-center z-[2]">
            <template v-if="arabian">
              <NuxtLink to="/login" class="min-w-[250px] mx-auto uppercase text-lg font-bold bg-white text-black p-3 hover:bg-veryDarkGray hover:text-white border-2 hover:border-white ">register</NuxtLink>
            </template>
            <template v-else>
              <NuxtLink to="/subscribe" class="min-w-[250px] mx-auto uppercase text-lg font-bold bg-white text-black p-3 hover:bg-veryDarkGray hover:text-white border-2 hover:border-white ">subscribe</NuxtLink>
            </template>
            <div v-if="!userName" class="min-w-[250px] mx-auto">
              <p class="py-2 text-grayLight text-tiny">OR</p>
              <p class="text-white mb-2">Are You a Member?</p>
            </div>
            <NuxtLink v-if="!userName" to="/login" class="min-w-[250px] mx-auto uppercase text-lg font-bold p-3 border-2 border-white hover:bg-darkRed text-white">login</NuxtLink>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap" v-else>
        <div class="flex w-full flex-wrap mb-3">
          <div class="w-full flex flex-wrap justify-center">
            <div class="flex items-center w-3/5 sm:w-2/5 lg:w-1/5 ">
              <label class="w-1/4 block font-bold text-tiny">Year :</label>
              <div class="relative w-1/2 border-none max-h-9">
                <select v-model="year"
                        class="text-black-400 border border-black-500  inline-block py-2 pl-3 pr-8 rounded leading-tight w-full"
                        @change="getPageInfo()">
                  <option v-for="item in years" :value="item">{{ item }}</option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
                  <i class="fas fa-chevron-down text-gray-400"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-3/4 bg-grey">
          <div class="border border-gray-300 border-x-0 border-t-0 text-tiny md:text-base">
            <button v-for="breed in breeds"  @click="sortByBreed(breed.id)"
                    :class="(selectedBreed === breed.id)? '-mb-px p-1 md:py-2.5 md:px-3.5 border border-b-white rounded-b-none focus:border-b-white focus:border-gray-300 rounded hover:bg-gray-100 hover:opacity-70':'-mb-px py-2.5 px-3.5 border rounded-b-none border-white border-b-gray-300 focus:border-b-white focus:border-gray-300 rounded hover:bg-gray-100 hover:opacity-70'">
              {{ breed.name }}
            </button>
          </div>
          <div class="flex flex-row flex-wrap justify-between py-2 text-xs sm:text-base">
            <select v-model="selectedAaad"
                    class="mt-1 py-2 px-3 border focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    @change="getData()">
              <option v-for="item in aaads_options" :value="item.id">{{ item.name }}</option>
            </select>
          </div>
          <div>
            <div v-if="readyTable">
              <table class="w-full">
                <thead class="border border-1 border-b-2 border-b-slate-900">
                <tr class="">
                  <td class="p-1 md:p-3 w-[8%] text-center">Position</td>
                  <td class="p-1 md:p-3 w-[28%]">Name</td>
                  <td class="p-1 md:p-3 w-[28%]">Points</td>
                  <td class="p-1 md:p-3 w-[28%]">Classes</td>
                  <td class="p-1 md:p-3 w-[8%] text-center">Shows</td>
                </tr>
                </thead>
                <tbody class="table-content-2 markup_content border border-1 border-b-4 text-tiny">
                <tr class="border border-1 align-top" v-for="item in items">
                  <td class="p-1 md:p-3 w-[8%] text-center">
                    <span class="font-bold">{{ item.position }}</span>
                  </td>
                  <td class="p-1 md:p-3 w-[28%]">
                    <NuxtLink :to="((selectedBreed !== 1571)? '/horse/':'/rider/')+item.permalink" class="text-darkRed hover:opacity-70 hover:text-darkBlue underline"><span>{{ item.name }}</span></NuxtLink>
                  </td>
                  <td class="p-1 md:p-3 w-[28%]">
                    <span>{{ item.points }}</span>
                  </td>
                  <td class="p-1 md:p-3 w-[28%]">
                    <span>{{ item.classes }}</span>
                  </td>
                  <td class="p-1 md:p-3 w-[8%] text-center">
                    <span>{{ item.shows }}</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <LoadersSpinner />
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/4 p-4">
          <div class="ql-snow">
            <div class="ql-editor" style="white-space: normal;">
              <div class="mb-4" v-html="pages.content"></div>
            </div>
          </div>
          <div class="flex flex-col text-center">
            <template v-for="item in page_downloads">
              <a :href="pdfURL + item.download" class="text-darkRed hover:opacity-70 hover:text-darkBlue underline" href=""><span>{{item.download_name}}</span></a>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <LoadersSpinner />
    </div>
  </div>
</template>
<script setup>
import {computed, ref} from 'vue';
import {http} from "~/utils/http";
import {Page, PageDownload} from "~/composables/nhTypes"
import {useSiteTitle, useSiteURL} from "~/composables/state";
import { useMainStore} from '~/stores/main'

const siteTitle = useSiteTitle();
const arabian = ref(siteTitle.value.includes('Arabian'));
const siteURL = useSiteURL();
const pdfURL = ref('');
const breeds = ref([]);
const aaads = ref([]);
const aaads_options = ref([]);
const items = ref([]);
const page_downloads = ref(new PageDownload);
const pages = ref(new Page);
const selectedBreed = ref(null);
const selectedAaad = ref(null);
const year = ref(new Date().getFullYear())
const years = ref([]);
const ready = ref(false);
const readyTable = ref(false);
const isLoggedIn = ref(true);
const mainStore = useMainStore()
const userName = computed(() => mainStore.userName)

const getData = async () => {
  items.value = [];
  readyTable.value = false;
  try {
    await http
        .get("/api/results/point", {
          params: {
            type: 'aas',
            year: year.value,
            aaad_id: selectedAaad.value,
            breed_id: selectedBreed.value
          }
        })
        .then((response) => {
          let raw_data = response.data.scores;

          raw_data = raw_data.sort((a, b) => {
            if (a.points > b.points) {
              return -1
            }
            if (a.points < b.points) {
              return 1
            }
            return 0
          })

          raw_data.forEach((item,index) => {
            items.value.push({
              position: index+1,
              name: item.name,
              points: item.points,
              classes: item.classes,
              shows: item.shows,
              permalink: item.permalink
            })
          })
        });
  } catch (e) {
    if(e.response?.status === 403 || e.response?.status === 401){
      isLoggedIn.value = false;
    }
    ready.value = true;
  }
  readyTable.value = true;
}

const getPageInfo = async () => {
  items.value = [];
  readyTable.value = false;
  try {
    await http
        .get("/api/results/point", {
          params: {
            type: 'aas',
            year: year.value,
          }
        })
        .then((response) => {
          years.value = response.data.years;
          selectedAaad.value = 1;
          selectedBreed.value = 1;
          breeds.value = response.data.breeds;
          aaads.value = response.data.aaads;
          aaads.value = aaads.value.sort((a, b) => {
            if (a.name < b.name) {
              return -1
            }
            if (a.name > b.name) {
              return 1
            }
            return 0
          })
          sortByBreed(breeds.value[0].id);
          ready.value = true;
          getData();
        });
  } catch (e) {
    if(e.response?.status === 403 || e.response?.status === 401){
      isLoggedIn.value = false;
    }
    ready.value = true;
  }
  ready.value = true;
  readyTable.value = true;
}


const sortByBreed = (breed_id) => {
  selectedBreed.value = breed_id;
  aaads_options.value = aaads.value.filter((item)=>item.breed_id===breed_id);
  selectedAaad.value = aaads_options.value[0].id;
  getData();
}

const getPages = async () => {
  try {
    await http
        .get("/api/pages/" + 4)
        .then((response) => {
          pages.value = response.data.page;
          pdfURL.value = siteURL.value + '/storage/downloads/results/' + pages.value.path + '/';
        });
  } catch (e) {
    console.log(e.response.data.error);
  }
  await getDownloads();
};

const getDownloads = async () => {
  try {
    await http
        .get("/api/pages-download/" + pages.value.id)
        .then((response) => {
          page_downloads.value = response.data.files;
        });
  } catch (e) {
    console.log(e.response.data.error);
  }
};

Promise.all([getPageInfo(),getPages()]);
</script>
